import { CONTACT_US_EMAIL } from '@dtx-company/app/shared/common/src/constants'
import { Link as DecoratedLink, Stack, Typography } from '@dtx-company/design-system/src'
import { FC } from 'react'
import { createMailToLink } from '@dtx-company/true-common/src/utils/createMailToLink'

export const SubscriptionErrorMessage: FC = () => {
  return (
    <Stack direction="row" justifyContent="center" alignItems="center" sx={{ mt: 4 }}>
      <Typography
        data-testid={'subscription-error-message'}
        color={'error'}
      >{`Sorry, an error occurred. Please refresh the page and `}</Typography>
      &nbsp;
      <DecoratedLink
        href={createMailToLink(CONTACT_US_EMAIL, {
          subject: 'Update Page Error',
          body: `I am having trouble paying for a Flowcode account. Can you help me?`
        })}
      >
        CONTACT US
      </DecoratedLink>
      &nbsp;
      <Typography color={'error'}>{` if the problem persists.`}</Typography>
    </Stack>
  )
}
